(function($){



  $('.header__nav-button').click(function(){
    $(this).toggleClass('header__nav-button_open');
    $('body').toggleClass('open-menu');
  })

  $('.page-overlay').click(function(){
    $('.header__nav-button').removeClass('header__nav-button_open');
    $('body').removeClass('open-menu');
  })
  
$('.nav_element.has-normal-dropdown > a').click(function(e) {
  if ($(window).width() < 992) {
    e.preventDefault();
    $(this).toggleClass('open');
    $(this).next('.header__submenu').slideToggle();
  }
});


   

     $('.cart_link').click(function () {
          $('.g-side-cart').addClass('active');
          $('body').addClass('no-scroll cart-open');
          $('.page-overlay').addClass('active');
        })
         


    $(document).on('click', '.page-overlay', function(){
 $('body').removeClass('no-scroll cart-open');
  $(this).removeClass('active');
  $('.g-side-cart').removeClass('active')
})


        $('.open-modal').magnificPopup({
  type:'inline',
  fixedContentPos: true,
  midClick: true // Allow opening popup on middle mouse click. Always set it to true if you don't provide alternative source in href.
});


 


 



})(jQuery);


(function ($) {
  'use strict';

  // ─── Shopify Helpers ────────────────────────────────────────────────────────

  Shopify.fullMessagesFromErrors = function (errors) {
    var messages = [];
    $.each(errors, function (field, errs) {
      $.each(errs, function (_, msg) {
        messages.push(field + ' ' + msg);
      });
    });
    return messages;
  };

  Shopify.onError = function (xhr) {
    var data;
    try {
      data = JSON.parse(xhr.responseText);
    } catch (e) {
      alert('An unexpected error occurred.');
      return;
    }
    var msg = data.message
      ? data.message + ' (' + data.status + '): ' + data.description
      : 'Error: ' + Shopify.fullMessagesFromErrors(data).join('; ') + '.';
    alert(msg);
    $('.addtocart, #AddToCart, #button2').prop('disabled', false);
  };

  Shopify.onSuccess = function () {
    $('.addtocart, #AddToCart, #button2').prop('disabled', false);
    refreshCart();
  };

  // ─── Cart Refresh ────────────────────────────────────────────────────────────

  function refreshCart() {
    $.ajax({
      type: 'GET',
      url: '/cart',
      dataType: 'html',
      success: renderCart,
    });
  }

  function renderCart(html) {
    var $html   = $('<div>').append($(html));
    var count   = $html.find('.countja').html();
    var ajCart  = $html.find('.g-side-cart').html();

    // Update cart icon count
    $(".cart-i").html(
      '<img loading="lazy" width="21" height="19" ' +
      'src="//cdn.shopify.com/s/files/1/0277/5118/6565/t/42/assets/cart-icon.svg?v=15670789903327946199">' +
      '<span>' + count + '</span>'
    );

    // Update cart drawer contents
    $('.g-side-cart').html(ajCart);

    // Open cart drawer
    $('body').addClass('cart-open');
    $('.g-side-cart').addClass('active');

    // Fix discount input name (prevent accidental submission)
    $('.input--discount').attr('name', 'discounta');

    // Re-bind dynamic cart elements after DOM update
    bindCartDrawerEvents();
  }

  // ─── AJAX: Add to Cart ───────────────────────────────────────────────────────

  function addItem(formId) {
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      dataType: 'json',
      data: $('#' + formId).serialize(),
      success: Shopify.onSuccess,
      error: Shopify.onError,
    });
  }

  // ─── AJAX: Change Line Item ──────────────────────────────────────────────────

  function changeItem(line, qty, $item) {
    $item.addClass('is-loading');
    $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      dataType: 'json',
      data: { quantity: qty, line: line },
      success: Shopify.onSuccess,
      error: Shopify.onError,
    });
  }

  // ─── Cart Drawer Events (re-bound after each render) ─────────────────────────

  function bindCartDrawerEvents() {
    var $cart = $('.g-side-cart');

    // Remove item
    $cart.find('.rem').off('click').on('click', function (e) {
      e.preventDefault();
      var $item = $(this).closest('.single');
      changeItem($item.data('line'), 0, $item);
    });

    // Qty stepper — update input value
    $cart.find('.g-qty-option .qtybtn').off('click').on('click', function () {
      var $btn   = $(this);
      var $input = $btn.siblings('input');
      var val    = parseFloat($input.val()) || 0;
      $input.val($btn.hasClass('g-btn-plus') ? val + 1 : Math.max(0, val - 1));
    });

    // Qty stepper — submit change (debounced so rapid clicks only fire once)
    $cart.find('.g-qty-option .qtybtn').on('click', debounce(function () {
      var $btn  = $(this);
      var $item = $btn.closest('.single');
      var qty   = $btn.siblings('input').val();
      changeItem($item.data('line'), qty, $item);
    }, 400));

    // Add to cart inside drawer
    $cart.find('.add_to_cart_buttona').off('click').on('click', function (e) {
      e.preventDefault();
      var $el = $(this);
      $el.closest('.single').addClass('is-loading');
      addItem($el.closest('form').attr('id'));
    });
  }

  // ─── Utility: Debounce ───────────────────────────────────────────────────────

  function debounce(fn, delay) {
    var timer;
    return function () {
      var ctx  = this;
      var args = arguments;
      clearTimeout(timer);
      timer = setTimeout(function () { fn.apply(ctx, args); }, delay);
    };
  }

  // ─── Document Ready ──────────────────────────────────────────────────────────

  $(document).ready(function () {

    // Toggle cart drawer via cart icon
    $(document).on('click', '.cart-i', function () {
      $('body').toggleClass('cart-open');
    });

    // Close cart drawer
    $(document).on('click', '.g-cart-close', function () {
      $('body').removeClass('cart-open');
    });

     $(document).on('click', '.close_cart', function () {
       $('.g-side-cart').removeClass('active');
          $('body').removeClass('no-scroll cart-open');
          $('.page-overlay').removeClass('active');
    });


     
    // Add to cart — product page buttons
    $(document).on('click', '.add_to_cart_buttona', function (e) {
      e.preventDefault();
      $(this).closest('.single').addClass('is-loading');
      addItem($(this).closest('form').attr('id'));
    });

    $(document).on('click', '.add_to_cart_button', function () {
      $(this).addClass('select-btn');
      addItem($(this).closest('form').attr('id'));
    });

    // Add to cart — PDP primary buttons
    $('#AddToCart, #button2').on('click', function (e) {
      e.preventDefault();
      $(this).prop('disabled', true);
      addItem($(this).closest('form').attr('id'));
    });

    // Global remove (outside drawer, e.g. cart page)
    $(document).on('click', '.rem', function (e) {
      e.preventDefault();
      var $item = $(this).closest('.single');
      changeItem($item.data('line'), 0, $item);
    });

  });

})(jQuery);









